<template>
    <AuthLayout class="music-library-frame-layout">
        <FullscreenLoading v-if="isLoading" />

        <div class="mb-3 mt-3 d-flex align-items-center">
            <h3 class="mb-0">{{ $t('users.title') }}</h3>

            <div class="ml-auto text-right">
                <router-link tag="button" class="btn btn-secondary btn-xs ml-3" :to="{ name: 'ceremonies' }">
                    <icon name="arrow-left" class="mr-1"></icon>
                    {{ $t('general.back') }}
                </router-link>
            </div>
        </div>

        <div v-if="!errorMessage" class="card">
            <div class="card-header pb-3">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-sm-flex w-100 align-items-center">
                        <span class="h4">{{ $t('users.title') }}</span>

                        <div class="ml-auto text-right">
                            <InviteUserAction v-if="store.getters.hasPermission('inviteUser')" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <UsersTable />
            </div>
        </div>

        <div class="p-1" v-if="errorMessage">
            <div class="alert alert-danger">
                {{ errorMessage }}
            </div>
        </div>
    </AuthLayout>
</template>

<script setup>
    import AuthLayout from './AuthLayout.vue';
    import { onMounted, ref } from 'vue';
    import { IpcCall, ipcCall } from '../utils/ipcCall';
    import i18n from '../../utils/locale';
    import store from '../../store/store';
    import FullscreenLoading from '../../components/FullscreenLoading.vue';
    import InviteUserAction from '../../components/users/InviteUserAction.vue';
    import UsersTable from '../../components/users/UsersTable.vue';

    const isLoading = ref(false);
    const errorMessage = ref(null);

    onMounted(async () => {
        isLoading.value = true;
        errorMessage.value = null;

        try {
            const isOnline = await ipcCall(IpcCall.CheckIfOnline);

            if (!isOnline) {
                errorMessage.value = i18n.t('users.users_offline_error');
                isLoading.value = false;
            }
        } catch (exception) {
            console.error(exception);
        } finally {
            isLoading.value = false;
        }
    });
</script>
